import React, { Suspense, useLayoutEffect, useState } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AuthenticatedLayout from "./AuthenticatedLayout";
import { PageLoadingVeil } from "../ui/composites/page-loading-veil";
import {
  bootstrapImpersonationHandoffs,
  hasImpersonationHandoffParams,
} from "../../utils/impersonationHandoff";

/**
 * Single persistent shell for all authenticated routes.
 * TopBar + Sidebar stay mounted; only the inner Switch content swaps.
 */
export default function AuthenticatedShell({ children }) {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const location = useLocation();
  const [awaitingHandoff, setAwaitingHandoff] = useState(
    () => !token && hasImpersonationHandoffParams()
  );

  useLayoutEffect(() => {
    if (!awaitingHandoff) return;
    bootstrapImpersonationHandoffs(dispatch);
    setAwaitingHandoff(false);
  }, [awaitingHandoff, dispatch]);

  if (awaitingHandoff) {
    return <PageLoadingVeil compact className="relative min-h-screen" />;
  }

  if (!token) {
    return <Redirect to={{ pathname: "/login", state: { from: location } }} />;
  }

  return (
    <AuthenticatedLayout key={token}>
      <Suspense fallback={<PageLoadingVeil compact className="relative min-h-[12rem]" />}>
        {children}
      </Suspense>
    </AuthenticatedLayout>
  );
}
